<div style="display: flex; flex-direction: row-reverse">
  <div
    class="purchase-order-form"
  >
    <div class="purchase-order-form-title">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div id="createPurchaseOrder" style="flex: 1">View Purchase Order</div>
        <button
          mat-button
          color="primary"
          style="
            font-size: 18px;
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 24px;
            padding-bottom: 24px;
          "
          (click)="close(true)"
        >
          Close<mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </div>

    <div
      class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4"
      style="width: 100%"
    >
      <mat-card class="p-0" style="margin: 0 0.5rem">
        <mat-card-content class="ship-fscoll hgt ship-pr-sec">
          <nav mat-tab-nav-bar class="tagGroup">
            <a
              mat-tab-link
              *ngFor="let tabItem of tabs; let idx = index"
              [class.active-link]="currentTab === tabItem.route"
              class="teb_icon"
              (click)="selectMatTabLink(tabItem)"
            >
              <span id="navstepstext">{{ tabItem.label }}</span>
            </a>
          </nav>

          <div class="mat-tab-body-content pos-relative">
            <div>
              <form [formGroup]="paymentFormGroup">
                <!-- Buyer Payment Terms -->
                <div class="header-form">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('form1')"
                  >
                    
                    <div style="display: flex; align-items: center;">
                      Buyer Payment Terms
                      <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            matTooltipClass="mat-tooltip-custom"
                            matTooltipPosition="left"
                            [matTooltip]="paymentTermsTooltip">

                            <mat-icon>info_outline</mat-icon>

                          </button>
                     </div>
                    <mat-icon>{{
                      isForm1Expand ? "minimize" : "add"
                    }}</mat-icon>
                  </span>

                  <div *ngIf="isForm1Expand" class="three-column-flex">
                    <div class="form-item-row">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Billing Address</mat-label>
                        <!-- <input matInput formControlName="billingAddress" readonly/> -->
                        <mat-select formControlName="billingAddress" placeholder="">
                          <mat-option *ngFor="let item of billingAddressData" [value]="item.address">{{ item.address }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="form-item-row">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Applicable Tax Profile</mat-label>
                        <input
                          matInput
                          formControlName="applicableTaxProfile"
                          readonly
                        />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Buyers Payment Terms</mat-label>
                        <input matInput formControlName="buyersPaymentTerms" readonly/>
                      </mat-form-field>
                    </div>

                    <div class="form-item-row" style="grid-column: span 3;flex: 0 0 63.2%;margin-top:20px;">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Terms and Conditions</mat-label>
                        <textarea
                          matInput
                          formControlName="buyerTermsAndConditions"
                          readonly
                        ></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Port Agent Details -->
                <div class="header-form">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('form2')"
                  >
                    <span>Port Agent Details <span style="color: red;">*</span>
                      
                      <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            matTooltipClass="mat-tooltip-custom"
                            matTooltipPosition="left"
                            [matTooltip]="portAgentTooltip">

                            <mat-icon>info_outline</mat-icon>

                          </button>
                     </span>
                    <mat-icon>{{
                      isForm2Expand ? "minimize" : "add"
                    }}</mat-icon>
                  </span>

                  <div *ngIf="isForm2Expand" class="three-column-flex">
                    <div class="form-item-row">
                      <!-- <mat-form-field class="full-width" color="accent">
                        <mat-label>Port Agency Name</mat-label>
                        <input matInput formControlName="portAgencyName" readonly/>
                      </mat-form-field> -->
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Port Agency Name</mat-label>
                        <mat-select formControlName="portAgentId" (selectionChange)="onPortAgentSelected($event.value)" >
                            <mat-option *ngFor="let item of portAgentData" [value]="item.id">{{ item.portAgencyName }}</mat-option>
                        </mat-select>
                            <button mat-icon-button matSuffix type="button">
                                            
                              <mat-icon matSuffix class="valid-icon"
                                  *ngIf="paymentFormGroup.get('portAgentId')?.valid && paymentFormGroup.get('portAgentId')?.value">
                                  check_circle
                              </mat-icon>

                              <mat-icon matSuffix class="invalid-icon" *ngIf="!paymentFormGroup.get('portAgentId')?.value">
                                cancel
                              </mat-icon>
                      
                          </button>
                      </mat-form-field>
                    </div>
                    <div class="form-item-row">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Port Agent Name</mat-label>
                        <input matInput formControlName="portAgentName" readonly />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Port Agent Phone Number</mat-label>
                        <input
                          matInput
                          formControlName="portAgentPhoneNumber"
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Port Agent Contact</mat-label>
                        <input matInput formControlName="portAgentContact" readonly/>
                      </mat-form-field>
                    </div>
                    <div class="form-item-row">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Port Agent Phone Fax</mat-label>
                        <input matInput formControlName="portAgentPhoneFax" readonly/>
                      </mat-form-field>
                    </div>
                    <div class="form-item-row">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Email ID</mat-label>
                        <input matInput formControlName="portAgentEmail" readonly/>
                      </mat-form-field>
                    </div>
                    <div class="form-item-row" style="grid-column: span 3">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Address</mat-label>
                        <input
                          matInput
                          formControlName="portAgentAddress"
                          readonly
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Terms and Conditions -->
                <div class="header-form">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('form3')"
                  >
                    
                    <div style="display: flex; align-items: center;">
                      Terms and Conditions
                      <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            matTooltipClass="mat-tooltip-custom"
                            matTooltipPosition="left"
                            [matTooltip]="termsTooltip">

                            <mat-icon>info_outline</mat-icon>

                          </button>
                     </div>
                    <mat-icon>{{
                      isForm3Expand ? "minimize" : "add"
                    }}</mat-icon>
                  </span>

                  <div *ngIf="isForm3Expand" class="three-column-flex">
                    <div class="form-item-row" style="grid-column: span 3;margin-top:20px">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Terms and Condition</mat-label>
                        <!-- <input
                          matInput
                          formControlName="termsAndConditions"
                        > -->
                        <textarea
                          matInput
                          formControlName="termsAndConditions"
                          readonly
                        ></textarea>
                      </mat-form-field>
                    </div>

                    
                    <div class="form-item-row" style="grid-column: span 3;height: 160px;">
                      <ngx-file-drop
                            class="w100 file-drop-zone"
                            dropZoneLabel="Drop files here"
                            (onFileDrop)="onAddtionalFileSelected($event)"
                            (onFileOver)="fileOver($event)"
                            (onFileLeave)="fileLeave($event)"
                            accept=".svg,.SVG,.png,.PNG,.jpeg,.JPEG,.jpg,.JPG,.pdf,.PDF"
                          >
                            <ng-template
                              style="display: flex; flex-direction: row"
                              ngx-file-drop-content-tmp
                              let-openFileSelector="openFileSelector"
                            >
                              <div class="drag-file">
                                <mat-icon>cloud_upload</mat-icon>
                                <p>Drag & drop the file here or</p>
                                <div (click)="openFileSelector()">
                                  <p style="color: #74c5b5">upload a file</p>
                                </div>
                                <p>*PDF, JPG or PNG</p>
                              </div>
                            </ng-template>
                        </ngx-file-drop>
                    </div>
                    <div class="form-item-row">
                      <div class="file-name-box">
                        {{
                          getHeaderAttachmentCount() === 0
                            ? "No files chosen"
                            : getHeaderAttachmentCount() === 1
                            ? "1 file chosen"
                            : getHeaderAttachmentCount() + " files chosen"
                        }}
                        <button
                            mat-icon-button
                            *ngIf="getHeaderAttachmentCount() > 0"
                            (click)="togglePreview(true, 'generalAttachment')"
                            type="button"
                          >
                            <mat-icon>visibility</mat-icon>
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- add new decument -->
      <!-- <div class="attachmentSidebar" style="overflow: auto;" *ngIf="showAddDocumentSection">
                <div class="sidebar-title" style="justify-content: space-between; padding:15px 15px; ;">
                  <div class="sidebar-title-text">Add New Document</div>
                  <div style="display: flex; justify-content: right; width: 50%; gap: 10px;">
                    
                    <span style="float: right;" class="pointer header-close-btn" matTooltipClass="mat-tooltip-custom" matTooltip="Close"
                      matTooltipPosition="below" (click)="toggleSidebar(false,'attachment')">
                      <mat-icon style="color: white;" >close</mat-icon>
                    </span>
                  </div>
                </div>
    
                <div class="sidebar-content" style="padding-top: 10px;">     
    
                    <mat-form-field class="full-width" color="accent">
                      <mat-label>Document Type</mat-label>
                      <mat-select [(ngModel)]="selectedAttachmentType">
                        <mat-option *ngFor="let item of headerAttachmentType" [value]="item.id"> {{item.documentTypeDescription}}</mat-option>
                      </mat-select>
                    </mat-form-field>
    
                <ngx-file-drop class="w100 file-drop-zone" dropZoneLabel="Drop files here" (onFileDrop)="onAttachmentChange($event)"
                (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" accept=".svg,.SVG,.png,.PNG,.jpeg,.JPEG,.jpg,.JPG,.pdf,.PDF">
                <ng-template style="display: flex; flex-direction: row;" ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    <div class="drag-file">
                        <mat-icon>cloud_upload</mat-icon>
                        <p> Drag & drop the file here or </p>
                        <div class="" (click)="openFileSelector()">
                            <p style="color:#74c5b5">upload a file</p>
                        </div>
                        <p> *PDF, JPG or PNG  </p>
                    </div>
                </ng-template>
            </ngx-file-drop>
    
          
            <div *ngIf="firstFormGroup.get('quoteHeaderAttachments')?.value" style="display: flex; flex-direction: column;">
                <h3 style="padding-top: 20px;">Header Attachments</h3>
                <div class="file-name-box" *ngFor="let file of firstFormGroup.get('quoteHeaderAttachments')?.value" >{{ file.name }}
                    <div *ngIf="file.attachmentId && file.attachmentId!=null">
                    
                                
    
                         <button mat-icon-button matTooltipClass="mat-tooltip-custom" matTooltip="View" matTooltipPosition="below" (click)="downloadDocument(file.url)">
                             <mat-icon>download</mat-icon>
                          </button>
    
                          <button mat-icon-button matTooltipClass="mat-tooltip-custom" matTooltip="Delete" matTooltipPosition="below" (click)="removeAttachment(file)">
                            <mat-icon>delete</mat-icon>
                         </button>   
                    </div>
                    
                </div>
            </div>
            
           
              
                  
                
               
                    <div class="button-container">
                        <button type="button" class="save-button" (click)="saveAttachment()">
                            <mat-icon>save</mat-icon>
                        </button>
                        <button type="button" class="close-button" (click)="toggleSidebar(false,'attachment')">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </div>
                </div>
              </div> -->
    </div>
  </div>
</div>

<!-- Popup for confirmation -->
<!-- <div class="namemodal" *ngIf="showDeclineConfirmationDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
                <p class="mb-6">Are you sure you want to decline this request for quotation?<br>Select a reason from the dropdown</p>
                <mat-form-field class="full-width" color="accent">
                    <mat-label>Decline reason</mat-label>
                    <mat-select [(ngModel)]="declineReason" >
                        
                        <mat-option value="Price is too high"> Price is too high</mat-option>
                        <mat-option value="Unable to meet specifications"> Unable to meet specifications</mat-option>
                        <mat-option value="Not available at this time"> Not available at this time</mat-option>
                        <mat-option value="No capacity to fulfill the order"> No capacity to fulfill the order</mat-option>
                        <mat-option value="Conflict of interest"> Conflict of interest</mat-option>
                        <mat-option value="Other"> Other</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="declineRfq()" [disabled]="declineReason == ''">Yes, Decline</button>
                    <button mat-stroked-button (click)="cancelDecline()">Cancel</button>
                </div>
            </div>
    
        </div>
    </div> -->

<!-- Popup for confirmation -->
<div class="namemodal" *ngIf="showCloseDialogue">
    <div class="modalContent">
        <div class="p-6 text-center">
            <div class="flex justify-center mb-4">
                <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                    <mat-icon class="text-orange-600"
                        style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                </div>
            </div>
            <p class="mb-6">You want to save this as draft?</p>
            <div class="flex justify-center gap-4">
                <button mat-raised-button color="primary" (click)="saveDraft(true)" style="margin-right: 5px;">YES</button>
                <button mat-stroked-button (click)="cancel()" style="margin-left:5px">NO</button>
            </div>
        </div>

    </div>
</div>

<!-- <div
    class="blur"
    *ngIf="headerAttachmentSection"
    (click)="toggleHeaderAttachmentImage(false)"
></div>
<div class="carousel-container" *ngIf="headerAttachmentSection">
    <div class="carousel-close-button">
    <button class="image-close-button" (click)="toggleHeaderAttachmentImage(false)">
        <mat-icon>cancel</mat-icon>
    </button>
    </div>
    <div class="carousel">
    

    <div class="carousel-image-container">
        <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(headerAttachmentUrl)"
        >
            <pdf-viewer
            [src]="headerAttachmentUrl"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="content"
            >
            </pdf-viewer>
        </div>
        <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(headerAttachmentUrl)"
        >
            <img
            [src]="headerAttachmentUrl"
            [alt]="'headerattachment image'"
            class="carousel-image"
            />
        </div>
    </div>

   
    </div>
</div> -->

<!-- <div
    class="blur"
    *ngIf="paymentTermsAndConditionsSection"
    (click)="togglePaymentTermsAndConditionsAttachment(false)"
></div>
<div class="carousel-container" *ngIf="paymentTermsAndConditionsSection">
    <div class="carousel-close-button">
    <button class="image-close-button" (click)="togglePaymentTermsAndConditionsAttachment(false)">
        <mat-icon style="font-size:20px">cancel</mat-icon>
    </button>
    </div>
    <div class="carousel">
   

    <div class="carousel-image-container">
        <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(paymentTermsAndConditionAttachmentUrl)"
        >
            <pdf-viewer
            [src]="paymentTermsAndConditionAttachmentUrl"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="content"
            >
            </pdf-viewer>
        </div>
        <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(paymentTermsAndConditionAttachmentUrl)"
        >
            <img
            [src]="paymentTermsAndConditionAttachmentUrl"
            [alt]="'headerattachment image'"
            class="carousel-image"
            />
        </div>
    </div>

   
    </div>
</div> -->

<!-- <div
    class="blur"
    *ngIf="buyerAttachmentsSection"
    (click)="toggleBuyerAttachments(false)"
></div>
<div class="carousel-container" *ngIf="buyerAttachmentsSection">
    <div class="carousel-close-button" style="display: flex; flex-direction: row; gap: 10px;">
    <button class="image-download-button" *ngIf="buyerAttachmentUrl.length>0"   (click)="downloadDocument(buyerAttachmentUrl[currentIndex])">
            <mat-icon style="font-size:20px">download</mat-icon>
    </button>

    <button class="image-close-button" (click)="toggleBuyerAttachments(false)">
        <mat-icon style="font-size:20px">cancel</mat-icon>
    </button>
    </div>
    <div class="carousel">
    <button class="carousel-control prev" (click)="prevSlide()">
        &#10094;
    </button>

    <div class="carousel-image-container">
        <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(buyerAttachmentUrl[currentIndex])"
        >
            <pdf-viewer
            [src]="buyerAttachmentUrl[currentIndex]"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="content"
            >
            </pdf-viewer>
        </div>
        <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(buyerAttachmentUrl[currentIndex])"
        >
            <img
            [src]="buyerAttachmentUrl[currentIndex]"
            [alt]="'headerattachment image'"
            class="carousel-image"
            />
        </div>
    </div>

    <button class="carousel-control next" (click)="nextSlide()">
        &#10095;
    </button>
    </div>
</div> -->

<!-- <div *ngIf="showNotification" class="notification-overlay"></div>


<div *ngIf="showNotification" 
     class="notification-popup" 
     [ngClass]="{'error-notification': notificationType === 'error', 'info-notification': notificationType === 'info', 'show': showNotification, 'hide': !showNotification}">
  <div class="notification-content">
    <div class="flex justify-center mb-4">
        <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
            <mat-icon class="text-orange-600"
                style="font-size: 75px;  height:100%; width:100%;">warning</mat-icon>
        </div>
    </div>
    <div class="notification-message" [innerHTML]="notificationMessage"></div> 
    <button (click)="dismissNotification()" class="btn-ok">OK</button>
  </div>
</div> -->




<div
  class="blur"
  *ngIf="previewSection"
  (click)="togglePreview(false, '')"
></div>

<div class="carousel-container" *ngIf="previewSection">
  <!-- Close Button -->
  <div class="carousel-close-button">
    <button class="image-close-button" (click)="togglePreview(false, '')">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>

  <!-- Carousel Content -->
  <div class="carousel">
    <!-- Previous Button -->
    <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
    </button>

    <!-- Image/PDF Preview -->
    <div class="carousel-image-container">
      <ng-container *ngIf="previewDoc[currentIndex]">
        <div
          class="carousel-preview-inner"
          *ngIf="isPdf(previewDoc[currentIndex]?.dataUrl)"
        >
          <pdf-viewer
            [src]="previewDoc[currentIndex].dataUrl"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="pdf-content"
          ></pdf-viewer>
        </div>

        <div
          class="carousel-preview-inner"
          *ngIf="!isPdf(previewDoc[currentIndex]?.dataUrl)"
        >
          <img
            [src]="previewDoc[currentIndex]?.dataUrl"
            alt="attachment image"
            class="carousel-image"
          />
        </div>
      </ng-container>
    </div>

    <!-- Next Button -->
    <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
    </button>
  </div>
</div>
